import type { MotionConfigSource } from '@cartwhl/common/api/getMotion';

import type { MotionExportSettings } from './motionExport';

export type CartographerMotionRetargetSurface = 'mini' | 'stage' | 'modal';

export interface CartographerMotionRetargetStatus {
  source: CartographerMotionRetargetSurface;
  motionID: string | null;
  bodyIndex?: number;
  configSource: MotionConfigSource;
  mappingRevisionKey: string | number | null;
  exportSettingsKey: string;
  userMotionUrl: string | null;
  loading: boolean;
  mainError: string | null;
  previewOutOfDate: boolean;
}

export function getMotionExportSettingsKey(settings: MotionExportSettings) {
  return `${settings.fps}|${settings.frameStep}|${settings.rootMotion}`;
}

export function getMotionRetargetStatusKey(
  status: Pick<
    CartographerMotionRetargetStatus,
    | 'motionID'
    | 'bodyIndex'
    | 'configSource'
    | 'mappingRevisionKey'
    | 'exportSettingsKey'
  >,
) {
  return `${status.motionID ?? ''}|${status.bodyIndex ?? 0}|${status.configSource}|${
    status.mappingRevisionKey ?? ''
  }|${status.exportSettingsKey}`;
}
